import AllSMSManagement from "../../components/Pages/Settings/SMSManagement";

const SMSManagement = () => {
  return (
    <div>
      <AllSMSManagement />
    </div>
  );
};

export default SMSManagement;
